import styled from 'styled-components'
import ButtonStyle from '@material-ui/core/Button'
import FormControlLabelStyle from '@material-ui/core/FormControlLabel'
import SwitchStyle from '@material-ui/core/Switch'

export const Container = styled.div`
	display: flex;
  	justify-content: space-between;
`
export const ActionContainer = styled.div`
	display: flex;
  	align-items: center;
  	grid-gap: 12px;
`
export const Title = styled.h3`
  	color: #242326;
  	font-size: 20px;
`

//@info mencionado no filtro do analitico do ticket.
export const FormControlLabel = styled(FormControlLabelStyle)`
	&& {
  		margin-left: 0;
	}
`
//@info mencionado no filtro do analitico do ticket.
export const Switch = styled(SwitchStyle)``
export const Button = styled(ButtonStyle)`
    && {
        height: 32px;
	  	background-color: #F6F7FC;
	  	color: #7D3CE8;
      	font-size: 14px;
      	&:hover {
        	background: #7D3CE8;
        	color: #FFFFFF;
      	}
	  	&.toggle {
		  	svg {
			  	width: 8px;
              	margin-right: 0;
              	margin-left: 7px;
			}
		}
	  	svg {
		  	height: 14px;
		  	margin-right: 7px;
		}
    }
`